module.exports = __webpack_public_path__ + "09_face.c3c4e12b.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/aoyama/mom/layer1/09_face.png
// module id = kate
// module chunks = 0